<template>
    <div style="margin-top: 1px;width: 100%;" v-if="modelValue">
        <el-date-picker @change="$emit('search',modelValue)" v-model="modelValue" style="width: 100%;" value-format="YYYY-MM-DD" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
    </div>
</template>
<script setup>
defineOptions({
    name: 'DateFilter'
})
const props = defineProps({
    column: {
        type: Object,
        default: () => ({})
    }
})

const modelValue = defineModel({local: true, default: [], type: Array})
</script>
<style>

</style>